import { render, staticRenderFns } from "./DeptUserInfo.vue?vue&type=template&id=dfe5a00a&scoped=true&"
import script from "./DeptUserInfo.vue?vue&type=script&lang=js&"
export * from "./DeptUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeptUserInfo.vue?vue&type=style&index=0&id=dfe5a00a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe5a00a",
  null
  
)

export default component.exports